module.exports = __webpack_public_path__ + "static/media/digital_rsvp.ac849e5d.svg";